import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import EnderecamentoCard from './components/EnderecamentoCard';

const DepositoEnderecamentoMain = () => {
  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader
            title=""
            routeSegments={[{ name: 'Inicio' }, { name: 'Deposito' }, { name: 'Enderecamento' }]}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <EnderecamentoCard />
        </Col>
      </Row>
    </Container>
  );
};

export default DepositoEnderecamentoMain;
